import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Portfolio from './Portfolio';
import LogoFlavor from './LogoFlavor';

const isMobileViewport = () => (
  typeof window !== 'undefined'
  && window.matchMedia('(max-width: 800px)').matches
);

const AppContent = () => {
  const location = useLocation();
  const [transitionClass, setTransitionClass] = useState(location.pathname === '/' ? 'home' : 'portfolio');
  const [isTextVisible, setIsTextVisible] = useState(true);
  const routeClass = location.pathname === '/' ? 'app--home' : 'app--portfolio';
  const logoScale = isMobileViewport() ? 81 : 80;
  const logoTextScale = isMobileViewport() ? 100 : 86;

  useEffect(() => {
    setIsTextVisible(false);

    const timeoutId = setTimeout(() => {
      setTransitionClass(location.pathname === '/' ? 'home' : 'portfolio');
      setIsTextVisible(true);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  return (
    <div
      className={`app app--plain-background ${routeClass}`}
      style={{
        '--logo-text-scale': logoTextScale / 100,
        '--logo-text-weight': 400,
        '--card-text-scale': 1,
        '--card-text-weight': 400,
        '--card-hover-duration': '1s'
      }}
    >
      <LogoFlavor transitionClass={transitionClass} isTextVisible={isTextVisible} logoScale={logoScale} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/infra" element={<Navigate to="/portfolio" replace />} />
        <Route path="/semis" element={<Navigate to="/portfolio" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>  
    </div>
  );
};

const App = () => {
  return (
    <Router> 
      <AppContent />
    </Router>
  );
};

export default App;
